import script from "./ChatAgentAssistance.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatAgentAssistance.vue?vue&type=script&setup=true&lang=js"

import "./ChatAgentAssistance.vue?vue&type=style&index=0&id=4827be64&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4827be64"]])

export default __exports__